import {
	AriaPopover,
	Markdown,
	moneyFormatNoDecimal,
	Stack,
	Text,
	useText,
} from "@sveabank/cc-common";
import BackgroundBleed from "../../components/background-bleed";
import Content from "../../components/content";
import Hide from "../../components/hide";
import type { CreditScoreStepState } from "../../types/step";
import { isCreditWorthy } from "./helpers";

type Props = {
	creditScore: CreditScoreStepState;
};

const CreditSummation = ({ creditScore }: Props) => {
	const [t, texts] = useText();

	const isRejected = !creditScore?.assessment || !isCreditWorthy(creditScore.assessment);

	return (
		<Hide to="tablet">
			<div className="mb-8">
				<BackgroundBleed className="bg-background-tertiary">
					<Content size={8} py={8}>
						{!isRejected ? (
							<Stack gap={4} direction="row">
								<Text className="text-sm" component="p">
									{t(texts.choosePackage.creditSummation.title)}
								</Text>
								<Text className="text-text-headline text-xl" bold component="p">
									{creditScore.assessment
										? moneyFormatNoDecimal(Number(creditScore.assessment.limit.amount), true)
										: "-"}
								</Text>

								<AriaPopover
									variant="info"
									content={() => (
										<Markdown allowParagraphs>
											{t(texts.choosePackage.tooltip.description)}
										</Markdown>
									)}
								/>
								<Text className="text-sm" component="p">
									{t(texts.choosePackage.creditSummation.description)}
								</Text>
							</Stack>
						) : (
							<div className="text-center">
								{t(texts.choosePackage.creditSummation.unavailable)}
							</div>
						)}
					</Content>
				</BackgroundBleed>
			</div>
		</Hide>
	);
};

export default CreditSummation;
